<template>
    <div class="hidden max-w-screen-lg w-full mx-auto p-2 bg-white space-x-4 items-center md:flex">
        <slot name="logo" />

        <slot />
    </div>
</template>
